import { Typography } from '@material-ui/core';
import { CardSistemasProps } from './card-voto-revenda-props';
import { DefaultCard } from '../components/default-card';
import { useDefaultCardStyles } from '../components/default-card/default-card-styles';
import { toDateString } from 'utils/to-date';
import { useThemeQueries } from 'views/theme';
import { useStyles } from './card-voto-revenda-style';
import { memo } from 'react';

export const CardVotoRevenda = memo(({
  model,
  onClick,
}: CardSistemasProps) => {
  const defaultCardClasses = useDefaultCardStyles();
  const { theme: { palette } } = useThemeQueries()
  const classes = useStyles()

  return (
    <>
      <DefaultCard
        onClick={() => {
          onClick(model.usuario);
        }}
        isClickable={false}
        className={classes.card}
      >
        <div
          className={defaultCardClasses.tagStatus}
          style={{
            backgroundColor: palette.primary.main,
          }}
        ></div>
        <div style={{
          padding: 8,
          width: '100%'
        }}>
          <div>
            <Typography
              style={{
                fontWeight: 600,
                fontSize: 13
              }}
              color="textSecondary"
              variant="body2"
            >
              {model?.usuario ?? 'Desconhecido'}
            </Typography>
            <Typography
              style={{
                fontSize: 12
              }}
              color="textSecondary"
              variant="body2"
            >
              {toDateString(model.data_voto, 'DD/MM/YYYY HH:mm')}
            </Typography>
          </div>
        </div>
        {/* <Tooltip arrow title="Visualizar Revenda">
          <div className={defaultCardClasses.cardRightButton} style={{ marginLeft: '10px' }}>
            <LinkIcon tipo="BUTTON" fill={palette.primary.main} />
          </div>
        </Tooltip> */}
      </DefaultCard>
    </>
  );
});

CardVotoRevenda.displayName = 'CardVotoRevenda';
